// extracted by mini-css-extract-plugin
export default {"bcrsLabel":"YkIqUtzhfzoFlWNu_VXo","bcrsLabelClickable":"zgZhEn_iIDCg2FyWE6A7","bcrsInfoIcon":"gXwcMrBlGbnpwHZ7GJGO","switchRow":"pAt04mjYyjUiiwi6mxG6"};